export const REQUEST_PART_FROM_DRAWER = gql`
  mutation RequestPartFromDrawer($input: RequestPurchaseOrderPartInput!) {
    requestPurchaseOrderPart(input: $input) {
      id
    }
  }
`
